// extracted by mini-css-extract-plugin
export default {"root":"_2lMEi","expanded":"_3UAvW"};